import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private config: any;

    async cargarConfig() {
        const res = await fetch(environment.configUrl);
        this.config = await res.json();

        this.applyTheme(this.config.theme);
        this.applyDarkMode(this.config.darkMode);
        this.setLogo(this.config);
    }

    private applyTheme(theme: any) {
        if (!theme) return;
        const root = document.documentElement;
        Object.keys(theme).forEach(key => {
            root.style.setProperty(`--${key}`, theme[key]);
        });
    }

    private applyDarkMode(isDark: boolean) {
        const root = document.body;
        if (isDark) {
            root.classList.add('dark-mode');
        } else {
            root.classList.remove('dark-mode');
        }
    }

    private setLogo(config: any) {
        const logoElement = document.getElementById('main-logo') as HTMLImageElement;
        if (logoElement) {
            logoElement.src = config.darkMode ? config.logoDark : config.logo;
        }
        const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (favicon && config.favicon) {
            favicon.href = config.favicon;
        }
    }

    get nombre(): string {
        return this.config?.nombre || '';
    }
}
